import { render, staticRenderFns } from "./MainLedgerLLACRUD.vue?vue&type=template&id=19272945"
import script from "./MainLedgerLLACRUD.vue?vue&type=script&lang=js"
export * from "./MainLedgerLLACRUD.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerLLACRUD.vue?vue&type=style&index=0&id=19272945&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports